import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../../../axios-order";
import CashLedgerTable from "./CashLeder";
import CircularProgress from "@mui/material/CircularProgress";
import { Typography, Tooltip, IconButton, Box } from "@mui/material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import CreditLedgerTable from "./CrediLedger";
import LiabilityLedgerTable from "./LiabilityLedger";
import RCMLedgerTable from "./RCMLedger";
import CreditReversalLedgerTable from "./CreditReversalLedger.js";


const GstLederDetailedReport = () => {
    let history = useHistory();
    const { report_id } = useParams();
    const [exportButtonLaoding, setExportButtonLaoding] = useState(false);
    const [responseData, setReponseData] = useState([]);
    const [reportType, setReportType] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getGstLederReportDetails();
    }, []);

    const downloadBase64Excel = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };


    const handleExcel = () => {
        setExportButtonLaoding(true)
        const payload = {
            "business_entity_id": localStorage.getItem("business_entity_id"),
            "report_id": report_id
        };
        axios
            .post("/gstn_get_ledger/generate_gstn_ledger_report", payload)
            .then((response) => {
                const contentType =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                const base64Data = response?.data?.file;
                if (base64Data) {
                    downloadBase64Excel(contentType, base64Data, `${reportType}.xlsx`);
                } else {
                    console.error("Base64 data is missing in the response");
                }
            })
            .catch((error) => {
                console.log(error)
            }).finally(() => {
                setExportButtonLaoding(false)
            })
    };

    const renderGSTLederDetailedTable = () => {
        switch (reportType) {
            case "CASH LEDGER":
                return <CashLedgerTable data={responseData} />;
            case "CREDIT LEDGER":
                return <CreditLedgerTable data={responseData} />;
            case "LIABILITY LEDGER":
                return <LiabilityLedgerTable data={responseData} />;
            case "RCM LIABILITY LEDGER":
                return <RCMLedgerTable data={responseData} />;
            case "CREDIT REVERSAL LEDGER":
                return <CreditReversalLedgerTable data={responseData} />;
            default:
                return <CashLedgerTable data={responseData} />;
        }
    };


    const getGstLederReportDetails = () => {
        axios.post("/gstn_get_ledger/view_gstn_ledger", { report_id })
            .then((res) => {
                if (res?.data?.status) {
                    const report_type = res?.data?.report_type || "";
                    let data = []
                    // let openingBalance = {};
                    // let closingBalance = {};
                    if (report_type === "CASH LEDGER") {
                         data = res?.data?.cash_ledger_records?.transactions || [];
                    }
                    else if (report_type === "LIABILITY LEDGER") {
                        data = res?.data?.cash_ledger_records?.transactions || [];
                    }
                    else if (report_type === "RCM LIABILITY LEDGER") {
                        data = res?.data?.cash_ledger_records?.transactions || [];
                        // openingBalance = res?.data?.cash_ledger_records?.opening_balance || {};
                        // closingBalance = res?.data?.cash_ledger_records?.closing_balance || {};
                    }
                    else if (report_type === "CREDIT REVERSAL LEDGER") {
                        data = res?.data?.cash_ledger_records?.transactions || [];
                        // openingBalance = res?.data?.cash_ledger_records?.opening_balance || {};
                        //closingBalance = res?.data?.cash_ledger_records?.closing_balance || {};
                    }
                    else {
                        data = res?.data?.credit_ledger_records || [];
                    }
                    
                    setReportType(report_type);
                    setReponseData(data);
                }
            })
            .catch((err) => {
                console.error("Error fetching data:", err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <>
            {isLoading ? (
                <Box textAlign="center" mt={5}>
                    <CircularProgress />
                    <Typography mt={2}>Loading, Please wait...</Typography>
                </Box>
            ) : (
                <>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                        <Typography
                            variant="h6"
                            sx={{
                                flexGrow: 1,
                                textAlign: 'center',
                                letterSpacing: '0.04rem',
                                fontFamily: `'Montserrat', sans-serif`,
                                textTransform: 'uppercase',
                                fontWeight: 'bold',
                                color: '#1D3557'
                            }}
                        >
                            {reportType} <AccountBalanceIcon sx={{ verticalAlign: 'middle' }} />
                        </Typography>
                        <Box>
                            <Tooltip title="Back" arrow>
                                <IconButton
                                    onClick={() => history.goBack()}
                                    sx={{
                                        borderRadius: '50%',
                                        padding: '8px',
                                        color: '#263238',
                                        marginRight: '10px',
                                        backgroundColor: '#ffffff',
                                        '&:hover': {
                                            backgroundColor: '#455a64',
                                            color: '#ffffff',
                                        },
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                                    }}
                                >
                                    <ArrowBackIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Export" arrow>
                                <IconButton
                                    onClick={handleExcel}
                                    color='success'
                                    sx={{
                                        borderRadius: '50%',
                                        marginLeft: '20px',
                                        padding: '8px',
                                        backgroundColor: '#ffffff',
                                        '&:hover': {
                                            backgroundColor: '#ccff90',
                                            color: '#000000',
                                        },
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                                    }}
                                >
                                    {exportButtonLaoding ? (
                                        <CircularProgress sx={{ color: '#1976d2' }} size={20} />
                                    ) : (
                                        <img
                                            style={{ height: 24, width: 24, objectFit: 'contain' }}
                                            src='https://img.icons8.com/?size=48&id=117561&format=png'
                                            alt="Export Icon"
                                        />
                                    )}
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Box>
                    {renderGSTLederDetailedTable()}
                </>
            )}
        </>
    );
};

export default GstLederDetailedReport;
